<div class="p-3 d-flex flex-column h-100">
  <div class="mb-3 d-flex justify-content-between align-items-center">
    <h5 class="mb-0">Clients</h5>
    <i class="ri-close-line ri-xl d-lg-none pointer" (click)="closeSideBar()"></i>
  </div>
  <div class="search-box">
    <input type="text" class="form-control bg-light border-light" placeholder="Search here...">
    <i class="ri-search-2-line search-icon"></i>
  </div>
  <ngx-simplebar class="mt-3 mx-n4 mb-2 px-4 file-menu-sidebar-scroll">
    <ul class="list-unstyled file-manager-menu">
      @for (item of clients; track item; let i = $index) {
        <li>
          <div routerLinkActive="activeProject">
            <i role="none" class="ri-building-4-line align-bottom me-2"></i>
            <span role="none" class="pointer" routerLink="{{ item.id }}" (click)="goToClient(item)">{{ item.name }}
              <div class="badge rounded-pill fs-8" [ngClass]="item.status === 'ACTIVE' ? 'bg-success' : item.status === 'PENDING' ? 'bg-warning' : 'bg-danger'">{{ item.status | titlecase }}</div>
            </span>
          </div>
        </li>
      }
    </ul>
  </ngx-simplebar>
</div>